import { render, staticRenderFns } from "./consentError.vue?vue&type=template&id=29acdf34&scoped=true"
import script from "./consentError.vue?vue&type=script&lang=ts"
export * from "./consentError.vue?vue&type=script&lang=ts"
import style0 from "./consentError.vue?vue&type=style&index=0&id=29acdf34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29acdf34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VMain,VRow})
